import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import LoginChoose from '../views/LoginChoose.vue';
import SalesManageLogin from '../views/SalesManageLogin.vue';
import StudentLogin from '../views/StudentLogin.vue';
import Admin from '../views/Admin.vue';
import AdminStudent from '../views/AdminStudent.vue';
import Sale from '../views/Sale.vue';
import SaleInside from '../views/SaleInside.vue';
import PurchaseHistory from '../views/PurchaseHistory.vue';
import PurchaseProgram from '../views/PurchaseProgram.vue';
import PurchaseProduct from '../views/PurchaseProduct.vue';
import CheckoutDetail from '../views/CheckoutDetail.vue';
import Payment from '../views/Payment.vue';
import Invoice from '../views/Invoice.vue';
import RollCall from '../views/RollCall.vue';
import RollCallInside from '../views/RollCallInside.vue';
import RollCallInsideStudent from '../views/RollCallInsideStudent.vue';
import CheckInDetail from '../views/CheckInDetail.vue';
import Register from '../views/Register.vue';
import Choose from '../views/Choose.vue';
import QrCode from '../views/QrCode.vue';
import QrCodeCustomer from '../views/QrCodeCustomer.vue';
import ManualCheckin from '../views/ManualCheckin.vue';
import ProductPlan from '../views/ProductPlan.vue';
import Checkout from '../views/Checkout.vue';
import OrderConfirmation from '../views/OrderConfirmation.vue';
import store from '@/store';
import { getToken } from '@/store/utils/user';

Vue.use(VueRouter);

const hostname = window.location.hostname;

const posRoutes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    children: [
      {
        name: '首頁',
        path: '',
        component: LoginChoose
      },
      {
        name: '銷售管理系統',
        path: 'sales-manage-login',
        component: SalesManageLogin
      },
      {
        name: '學員報到系統',
        path: 'student-login',
        component: StudentLogin
      }
    ]
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        name: '選擇頁',
        path: '',
        component: Choose
      },
      {
        path: 'sale',
        component: Sale,
        children: [
          {
            name: '銷售',
            path: '',
            component: SaleInside
          },
          {
            name: '歷史購買紀錄',
            path: 'purchase_history',
            component: PurchaseHistory
          },
          {
            name: '購買方案',
            path: 'purchase_program',
            component: PurchaseProgram
          },
          {
            name: '購買商品',
            path: 'purchase_product',
            component: PurchaseProduct
          },
          {
            name: '結帳明細',
            path: 'checkout_detail',
            component: CheckoutDetail
          },
          {
            name: '付款',
            path: 'pay_ment',
            component: Payment
          },
          {
            name: '開立發票',
            path: 'invoice/:order_id',
            component: Invoice
          }
        ]
      },
      {
        path: 'roll_call',
        component: RollCall,
        children: [
          {
            name: '課程點名',
            path: '',
            component: RollCallInside
          },
          {
            name: '報到詳細頁',
            path: 'check_in_detail/:schedule_time_id/:date',
            component: CheckInDetail
          },
          {
            name: 'QRcode頁面',
            path: 'qr_code/:schedule_time_id/:date',
            component: QrCode
          }
        ]
      },
      {
        name: '會員註冊',
        path: 'register',
        component: Register
      }
    ]
  },
  {
    path: '/admin_student',
    name: 'AdminStudent',
    component: AdminStudent,
    children: [
      {
        name: '學員報到',
        path: '',
        component: RollCallInsideStudent
      },
      {
        name: 'QRcode顧客頁面',
        path:
          'qr_code_customer/:schedule_time_id/:course_name/:date_time/:teacher_name',
        component: QrCodeCustomer
      },
      {
        name: '會員手動報到',
        path: 'manual_checkin/:schedule_time_id',
        component: ManualCheckin
      }
    ]
  }
];

const payRoutes = [
  {
    path: hostname === 'pay.whayoga.com' ? '/' : '/product-plan',
    name: 'ProductPlan',
    component: ProductPlan,
    meta: {
      favicon: '/pay-favicon.ico'
    }
  },
  {
    path: '/checkout/:program_id',
    name: 'Checkout',
    component: Checkout,
    props: route => ({ program_id: Number(route.params.program_id) }),
    meta: {
      favicon: '/pay-favicon.ico'
    }
  },
  {
    path: '/order-confirmation/:token',
    name: 'OrderConfirmation',
    component: OrderConfirmation,
    props: true,
    meta: {
      favicon: '/pay-favicon.ico'
    }
  }
];

let routes = [...payRoutes, ...posRoutes];

if (hostname === 'pos.whayoga.com') {
  routes = [...posRoutes];
} else if (hostname === 'pay.whayoga.com') {
  routes = [...payRoutes];
}

const router = new VueRouter({
  // mode:'history',    //開發時先不要打開
  linkActiveClass: 'active',
  routes
});

router.beforeEach((to, from, next) => {
  if (to.meta.favicon) {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = to.meta.favicon;
  }

  if (to.query.api_token) {
    store.commit('user/setToken', to.query.api_token);
  }

  if (to.query.select_member_id) {
    store.commit('member/setMemberId', to.query.select_member_id);
  }

  const token = getToken();
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (token) {
      next();
    } else {
      store.dispatch('user/logout');
    }
  } else {
    next();
  }
});

export default router;
